<template>
  <div class="woAppAuthHouseholdManageDetail">
    <div class="woAppFlex">
      <div class="filters">
        <div class="lineBox">
          <span>设备选择：</span>
          <el-select class="selectDevice" v-model="selectDevice" multiple placeholder="请选择授权设备">
            <el-option v-for="item in deviceList" :key="item.woDeviceNo" :label="item.woDeviceName"
              :value="item.woDeviceNo">
            </el-option>
          </el-select>
        </div>
        <div class="lineBox">
          <span>有效日期：</span>
          <el-date-picker v-model="validDate" value-format="timestamp" type="datetimerange" align="right"
            start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </div>
        <div class="lineBox">
          <el-button @click="authorize" :disabled="selectDevice.length==0||!validDate" type="primary">授权</el-button>
        </div>
      </div>
      <div class="filters h48">
        <div class="mb20">已授权设备列表</div>
        <el-table ref="multipleTable" :data="AuthDeviceList" tooltip-effect="dark" height="75%" style="width: 100%;"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="woDeviceName" label="设备名称">
          </el-table-column>
          <el-table-column prop="houseName" label="楼号">
          </el-table-column>
          <el-table-column prop="unitName" label="单元号">
          </el-table-column>
          <el-table-column prop="permissionEndTime" label="有效日期">
            <template slot-scope="scope">
              {{ scope.row.permissionEndTime | time }}
            </template>
          </el-table-column>
        </el-table>
        <div class="lineBox">
          <el-button @click="celAuthorize" :disabled="multipleSelection.length==0" type="primary">取消授权</el-button>
          <el-button @click="showEditValidDate = true" :disabled="multipleSelection.length==0" type="primary">延期</el-button>
          <el-date-picker @change="changeValidDate" v-if="showEditValidDate" v-model="editValidDate"
            value-format="timestamp" type="datetimerange" align="right" start-placeholder="开始日期" end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="filters w-300">
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_wj_returnNews')}}</el-button>
      </div>
      <div class="mb20">操作结果</div>
      <div class="operateDataBox" :class="item.state==1?'operateSuccess':'operateError'" v-for="item in operateData"
        :key="item.deviceNo">
        <span>{{item.deviceName}}</span>
        <span>{{item.deviceNo}}</span>
        <span>{{item.stateName}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   *@ClassName:woAppAuthHouseholdManageDetail
   *@Description:人像授权
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2022-06-23
   */
  import {
    mapGetters
  } from 'vuex'

  export default {
    data() {
      return {
        row: '', // 人像信息
        deviceList: [], // 所有设备列表
        selectDevice: [], // 选中设备列表
        validDate: '', // 有效日期
        AuthDeviceList: [], // 已授权设备列表
        multipleSelection: [], // 取消授权设备
        editValidDate: '', // 批量修改有效日期
        showEditValidDate: false, // 批量修改有效日期显示状态
        operateData: [], // 操作结果数据
      }
    },
    created() {
      this.row = this.$route.query.row
      console.log(this.row)
      this.getDeviceList()
      this.getAuthDeviceList()
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    watch: {
      // selectDevice(newVal, oldVal) {
      //   console.log(newVal)
      // },
    },
    methods: {
      // 返回上一级
      back() {
        this.$router.push({
          name: 'woAppAuthHouseholdManageList'
        })
      },
      // 获取设备列表
      getDeviceList() {
        let params = {
          garden: this.gardenId,
          admitGuid: this.row.admitGuid,
          pageNo: 1,
          pageSize: 999
        }
        this.$get('/woDevice', params).then(
          res => {
            console.log(res)
            if (res && res.errCode === 0) {
              this.deviceList = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 获取已授权设备列表
      getAuthDeviceList() {
        let params = {
          admitGuid: this.row.admitGuid,
          pageNo: 1,
          pageSize: 999
        }
        this.$get('/woDeviceAuth', params).then(
          res => {
            console.log(res)
            if (res && res.errCode === 0) {
              this.AuthDeviceList = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 设备授权
      authorize() {
        this.operateData = []
        var timestamp = new Date().getTime()
        if (timestamp >= this.validDate[1]) {
          this.$message.error('当前日期不能晚于结束日期')
        } else {
          for (let i = 0; i < this.selectDevice.length; i++) {
            let params = {
              garden: this.row.garden.id,
              admitGuid: this.row.admitGuid,
              permissionStartTime: this.validDate[0],
              permissionEndTime: this.validDate[1]
            }
            params.deviceNo = this.selectDevice[i]
            params.deviceName = this.deviceList.find(item => item.woDeviceNo === this.selectDevice[i]).woDeviceName
            this.$post('/woAuthDevice', params).then(
              res => {
                console.log(res)
                if (res && res.errCode == 0) {
                  console.log(params)
                  this.selectDevice = []
                  this.validDate = ''
                  this.getDeviceList()
                  this.getAuthDeviceList()
                  let obj = {
                    deviceNo: params.deviceNo,
                    deviceName: params.deviceName,
                    state: 1,
                    stateName: '授权成功'
                  }
                  this.operateData.push(obj)
                }
              },
              error => {
                this.$message.error(error)
                let obj = {
                  deviceNo: params.deviceNo,
                  deviceName: params.deviceName,
                  state: 2,
                  stateName: '授权失败'
                }
                this.operateData.push(obj)
              }
            )
          }
        }
      },
      // 已授权设备列表多选
      handleSelectionChange(val) {
        console.log(val)
        this.multipleSelection = val
      },
      // 取消授权（批量）
      celAuthorize() {
        this.operateData = []
        var params = {
          garden: this.row.garden.id,
          admitGuid: this.row.admitGuid,
        }
        for (let i = 0; i < this.multipleSelection.length; i++) {
          params.deviceNo = this.multipleSelection[i].woDeviceNo
          params.deviceName = this.multipleSelection[i].woDeviceName
          this.$delete('/woAuthDeviceRevoke', params).then(
            res => {
              console.log(res)
              if (res && res.errCode === 0) {
                this.getDeviceList()
                this.getAuthDeviceList()
                let obj = {
                  deviceNo: params.deviceNo,
                  deviceName: params.deviceName,
                  state: 1,
                  stateName: '取消授权成功'
                }
                this.operateData.push(obj)
              }
            },
            error => {
              this.$message.error(error)
              this.getDeviceList()
              this.getAuthDeviceList()
              let obj = {
                deviceNo: params.deviceNo,
                deviceName: params.deviceName,
                state: 1,
                stateName: '取消授权失败'
              }
              this.operateData.push(obj)
            }
          )
        }
      },
      // 延期（批量）
      changeValidDate(val) {
        if (val) {
          var timestamp = new Date().getTime()
          if (timestamp > val[1]) {
            this.$message.error('当前日期不能晚于结束日期')
          } else {
            this.operateData = []
            var params = {
              garden: this.row.garden.id,
              admitGuid: this.row.admitGuid,
              permissionStartTime: val[0],
              permissionEndTime: val[1]
            }
            for (let i = 0; i < this.multipleSelection.length; i++) {
              params.deviceNo = this.multipleSelection[i].woDeviceNo
              params.deviceName = this.multipleSelection[i].woDeviceName
              this.$post('/woAuthDevice', params).then(
                res => {
                  console.log(res)
                  if (res && res.errCode === 0) {
                    this.$message.success('修改成功')
                    this.editValidDate = ''
                    this.showEditValidDate = false
                    this.getAuthDeviceList()
                    let obj = {
                      deviceNo: params.deviceNo,
                      deviceName: params.deviceName,
                      state: 1,
                      stateName: '延期成功'
                    }
                    this.operateData.push(obj)
                  }
                },
                error => {
                  this.$message.error(error)
                  let obj = {
                    deviceNo: params.deviceNo,
                    deviceName: params.deviceName,
                    state: 1,
                    stateName: '延期成功'
                  }
                  this.operateData.push(obj)
                }
              )
            }
          }
        }
      }
    }
  }
</script>

<style lang='scss'>
  .woAppAuthHouseholdManageDetail {
    display: flex;
    height: 100%;
    overflow: auto;

    .woAppFlex {
      flex: 1;
    }

    .h48 {
      height: 50vh;
    }

    .w-300 {
      width: 400px;
      margin-left: 30px;

    }

    .filters .lineBox {
      margin-top: 30px;
    }

    .filters .selectDevice {
      width: 400px;
    }

    .mb20 {
      margin-bottom: 20px;
      font-weight: bold;
    }

    .operateDataBox {
      margin-bottom: 20px;

      span {
        display: inline-block;
        margin-right: 10px;
      }
    }

    .operateSuccess {
      background-color: #e6f7ec;
      border: 1px solid #2cbb61;
      border-radius: 5px;
      padding: 10px;
      color: #2cbb61;
    }

    .operateError {
      background-color: #ffcccc;
      border: 1px solid #ff4d4d;
      border-radius: 5px;
      padding: 10px;
      color: #ff4d4d;
    }

  }
</style>